import clamp from "lodash/clamp";

import { FLOATING_EXPANDABLE_BUBBLE_MARGIN, FLOATING_EXPANDABLE_BUBBLE_NAVBAR_WIDTH } from "../constants";

type Point = { left: number; top: number };
type Size = { width: number; height: number };
type Viewport = { width: number; height: number };

export const clampBoxToMainArea = (
  topLeft: Point,
  viewport: Viewport,
  boxSize: Size,
  margin: number = FLOATING_EXPANDABLE_BUBBLE_MARGIN,
  navbarWidth: number = FLOATING_EXPANDABLE_BUBBLE_NAVBAR_WIDTH
): Point => ({
  left: clamp(
    topLeft.left,
    margin + navbarWidth,
    Math.max(margin + navbarWidth, viewport.width - boxSize.width - margin)
  ),
  top: clamp(topLeft.top, margin, Math.max(margin, viewport.height - boxSize.height - margin))
});
